import { configureStore, Middleware, Tuple } from '@reduxjs/toolkit';
import { Action, Store } from 'redux';
import createSagaMiddleware from 'redux-saga';
import reducer from './reducer';
import rootSaga from './saga';
import { IState } from './state';

export type AppStore = Store<IState, Action>;

// persistent store to reference from different parts of the app
let store: AppStore;

function getStore(): AppStore {
  if (store) {
    // return existing store
    return store;
  }
  const sagaMiddleware = createSagaMiddleware();
  store = configureStore({
    reducer: reducer,
    // this typecasting is needed to avoid strange type discrepancy between redux-saga and rtk
    middleware: () => new Tuple(sagaMiddleware as Middleware),
  });
  sagaMiddleware.run(rootSaga, store.dispatch);
  return store;
}

export default getStore;
